// src/pages/Datenschutz.jsx
import React, { useEffect } from "react";
import { Layout, Typography, Divider } from "antd";
import PublicHeader from "../components/PublicHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutz – Patrick Sauter – Smart Routing";
  }, []);

  return (
    <Layout style={{ minHeight: "100vh", background: "#ffffff" }}>
      <PublicHeader />

      <Content style={{ maxWidth: 900, margin: "40px auto", padding: "0 16px" }}>
        <Title level={2}>Datenschutzerklärung</Title>

        <Paragraph>
          Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten beim Besuch dieser Website
          und bei der Nutzung von Smart Routing verarbeitet werden. Smart Routing ist eine Webanwendung zur Verwaltung
          und Optimierung von Fahrdiensten, Passagieren, Fahrzeugen und Touren.
        </Paragraph>

        <Divider />

        <Title level={3}>1. Verantwortlicher</Title>
        <Paragraph>
          Patrick Sauter<br />
          Sportplatzweg 11<br />
          72181 Starzach<br />
          E-Mail: info@patricksauter.de<br />
          Telefon: 0157 5579 0124
        </Paragraph>

        <Title level={3}>2. Arten der verarbeiteten Daten</Title>
        <Paragraph>
          Je nach Nutzung verarbeiten wir Bestandsdaten (z. B. Namen), Kontaktdaten (z. B. E-Mail-Adresse,
          Telefonnummer), Adress- und Standortdaten (z. B. Adressen, Koordinaten), Vertrags- und Nutzungsdaten
          (z. B. angelegte Passagiere, Fahrzeuge, Touren und Tourenparameter), Angaben zur Vermittlung eines
          Neukunden (z. B. Organisation, Kundennummer oder E-Mail-Adresse des Werbers) sowie technische Meta- und
          Verbindungsdaten (z. B. IP-Adresse, Zeitpunkt des Zugriffs, aufgerufene Seiten, User-Agent).
        </Paragraph>
        <Paragraph>
          Für die sichere und bedarfsgerechte Beförderungsplanung können außerdem Angaben zu besonderen
          Mobilitäts- oder Unterstützungsbedarfen verarbeitet werden, beispielsweise zur Nutzung eines Rollstuhls,
          eines E-Rollstuhls oder zu benötigten Hilfestellungen. Soweit solche Angaben Rückschlüsse auf den
          Gesundheitszustand einer Person zulassen, handelt es sich um besondere Kategorien personenbezogener Daten
          im Sinne von Art. 9 DSGVO. Sie dürfen nur erfasst werden, wenn sie für die Planung erforderlich sind und
          eine entsprechende Rechtsgrundlage nach Art. 9 DSGVO besteht. Erfolgt die Verarbeitung im Auftrag eines
          Kunden, ist dieser für die Zulässigkeit der Erhebung verantwortlich; Smart Routing verarbeitet die Daten
          ausschließlich zweckgebunden, weisungsgebunden und auf Grundlage eines Auftragsverarbeitungsvertrags.
        </Paragraph>

        <Title level={3}>3. Zwecke und Rechtsgrundlagen</Title>
        <Paragraph>
          Zwecke: Bereitstellung der Website und der Smart-Routing-Anwendung, Registrierung und Verwaltung von
          Nutzerkonten, Tourenplanung und Routenberechnung, Kommunikation und Support, Vertragsdurchführung,
          Abrechnung und Zuordnung von Empfehlungs-Gutschriften, IT-Sicherheit, Fehleranalyse und Erfüllung
          gesetzlicher Pflichten.
        </Paragraph>
        <Paragraph>
          Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Anbahnung), Art. 6 Abs. 1 lit. f DSGVO
          (berechtigte Interessen, insbesondere sicherer und stabiler Betrieb, Fehleranalyse und Schutz vor Missbrauch)
          sowie Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Pflichten, insbesondere steuer- und handelsrechtliche
          Aufbewahrungspflichten).
        </Paragraph>

        <Title level={3}>4. Hosting (Hetzner Cloud) & Server-Logs</Title>
        <Paragraph>
          Unser Onlineangebot wird in der Hetzner Cloud (Anbieter: Hetzner Online GmbH, Deutschland) betrieben.
          Beim Aufruf werden Server-Logdaten verarbeitet (IP-Adresse, Datum/Uhrzeit, aufgerufene Ressource, Referrer,
          User-Agent). Die Verarbeitung dient Betrieb, Sicherheit und Fehleranalyse (Art. 6 Abs. 1 lit. f DSGVO).
          Logdaten werden in der Regel nach kurzer Zeit gelöscht, sofern keine längere Aufbewahrung zur Aufklärung von
          Sicherheitsvorfällen erforderlich ist. Mit Hetzner besteht ein Vertrag zur Auftragsverarbeitung nach Art. 28
          DSGVO.
        </Paragraph>

        <Title level={3}>5. Backups (IONOS Object Storage)</Title>
        <Paragraph>
          Zur Sicherung der Verfügbarkeit und Wiederherstellbarkeit unseres Onlineangebots erstellen wir regelmäßige
          Backups des Serverzustands und der Datenbanken. Diese Backups werden in einem Object-Storage-Dienst der
          IONOS SE gespeichert und können personenbezogene Daten enthalten, soweit diese in der Anwendung oder
          in den gesicherten Serverbereichen verarbeitet werden. Die Verarbeitung dient der Datensicherheit,
          Ausfallsicherheit und Wiederherstellung im Störungsfall (Art. 6 Abs. 1 lit. f DSGVO). Backups werden
          regelmäßig überschrieben oder gelöscht. Mit IONOS besteht, soweit erforderlich, eine Vereinbarung zur
          Auftragsverarbeitung nach Art. 28 DSGVO.
        </Paragraph>

        <Title level={3}>6. Geodaten und Routen</Title>
        <Paragraph>
          Für Geokodierung, Distanz- und Routenberechnungen werden Adressen oder Koordinaten verarbeitet. Die
          Anwendung nutzt dafür Karten- und Routendaten, insbesondere auf Grundlage von OpenStreetMap-Daten, sowie
          Routingdienste wie GraphHopper, soweit dies für die Berechnung erforderlich ist. Dabei können
          Adressen, Koordinaten und technische Metadaten an den jeweiligen Dienst übermittelt werden.
        </Paragraph>
        <Paragraph>
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur Vertragserfüllung erforderlich
          ist, sowie Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses an einer funktionsfähigen und
          realistischen Tourenplanung. Bitte geben Sie in Freitextfeldern keine sensiblen Informationen ein, die für
          die Routenplanung nicht erforderlich sind.
        </Paragraph>

        <Title level={3}>7. Registrierung, Login und Nutzerkonto</Title>
        <Paragraph>
          Zur Nutzung geschützter Funktionen ist eine Registrierung erforderlich. Wir verarbeiten die von Ihnen
          angegebenen Daten (z. B. Name und E-Mail-Adresse) zur Einrichtung und Verwaltung des Kontos sowie zur
          Erfüllung unserer Leistungen (Art. 6 Abs. 1 lit. b DSGVO). Passwörter werden nicht im Klartext gespeichert.
          Sie können Ihr Konto löschen lassen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
        </Paragraph>

        <Title level={3}>8. E-Mail-Kommunikation (Zoho Mail)</Title>
        <Paragraph>
          Für die E-Mail-Kommunikation, insbesondere Kontaktanfragen, Support und systembezogene Nachrichten, nutzen
          wir Zoho Mail (Zoho Corporation). Dabei werden E-Mail-Adressen sowie Inhalts- und Metadaten der
          Kommunikation verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Kommunikation zur
          Vertragsdurchführung oder Vertragsanbahnung erfolgt, im Übrigen Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres
          berechtigten Interesses an einer zuverlässigen Kommunikation.
        </Paragraph>
        <Paragraph>
          Sofern es hierbei zu Übermittlungen in Drittländer außerhalb der EU/des EWR kommt, erfolgen diese nach den
          gesetzlichen Vorgaben, insbesondere auf Grundlage geeigneter Garantien wie EU-Standardvertragsklauseln.
        </Paragraph>

        <Title level={3}>9. Cookies und lokale Speicherung</Title>
        <Paragraph>
          Die Anwendung nutzt technisch notwendige Cookies oder lokale Speicherung, zum Beispiel zur Anmeldung und zur
          sicheren Bereitstellung geschützter Funktionen. Diese Speicherung ist erforderlich, um den ausdrücklich
          gewünschten Dienst bereitzustellen. Wir verwenden derzeit keine optionalen Tracking- oder Analyse-Cookies.
        </Paragraph>

        <Title level={3}>10. Empfänger und Auftragsverarbeitung</Title>
        <Paragraph>
          Personenbezogene Daten werden nur weitergegeben, wenn dies für die genannten Zwecke erforderlich ist, eine
          gesetzliche Pflicht besteht oder eine Rechtsgrundlage dies erlaubt. Empfänger oder Kategorien von Empfängern
          sind insbesondere Hosting- und Cloud-Dienstleister (Hetzner), Backup- und Speicherdienste (IONOS),
          E-Mail-Dienstleister (Zoho) sowie Routing- und Geocodingdienste wie GraphHopper, soweit diese für die
          Bereitstellung der jeweiligen Funktion erforderlich sind.
        </Paragraph>
        <Paragraph>
          Soweit Dienstleister personenbezogene Daten in unserem Auftrag verarbeiten, schließen wir Verträge zur
          Auftragsverarbeitung nach Art. 28 DSGVO. Wenn Smart Routing im Auftrag eines Kunden personenbezogene Daten
          von dessen Passagieren, Mitarbeitenden oder sonstigen betroffenen Personen verarbeitet, wird hierfür ein
          gesonderter Auftragsverarbeitungsvertrag mit dem Kunden geschlossen.
        </Paragraph>

        <Title level={3}>11. Drittlandtransfers</Title>
        <Paragraph>
          Eine Übermittlung personenbezogener Daten in Länder außerhalb der EU/des EWR erfolgt nur, wenn hierfür eine
          Rechtsgrundlage besteht und die gesetzlichen Voraussetzungen erfüllt sind, insbesondere durch einen
          Angemessenheitsbeschluss der EU-Kommission oder geeignete Garantien wie EU-Standardvertragsklauseln.
        </Paragraph>

        <Title level={3}>12. Speicherdauer</Title>
        <Paragraph>
          Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist oder
          gesetzliche Aufbewahrungspflichten bestehen. Kontodaten und in der Anwendung angelegte Daten werden
          grundsätzlich für die Dauer der Nutzung oder des Vertragsverhältnisses gespeichert. Geschäfts- und
          Abrechnungsunterlagen können aufgrund gesetzlicher Pflichten länger aufbewahrt werden. Nach Wegfall des
          Zwecks oder Ablauf gesetzlicher Fristen werden Daten gelöscht oder anonymisiert.
        </Paragraph>

        <Title level={3}>13. Sicherheit der Verarbeitung</Title>
        <Paragraph>
          Wir treffen angemessene technische und organisatorische Maßnahmen, um personenbezogene Daten gegen Verlust,
          Missbrauch, unbefugten Zugriff und unbefugte Veränderung zu schützen. Dazu gehören insbesondere
          Zugriffsbeschränkungen, verschlüsselte Übertragung, Berechtigungskonzepte und Backups.
        </Paragraph>
        <Paragraph>
          Identifizierende Angaben zu Passagieren, Einrichtungen und Standorten werden in der Datenbank
          pseudonymisiert und zusätzlich verschlüsselt gespeichert. Die zur Zuordnung beziehungsweise Entschlüsselung
          erforderlichen Schlüssel werden getrennt von der Datenbank verwahrt. Klarwerte werden nur im Rahmen
          berechtigter Anwendungsfunktionen verarbeitet. Pseudonymisierte Daten bleiben personenbezogene Daten im
          Sinne der DSGVO.
        </Paragraph>

        <Title level={3}>14. Ihre Rechte</Title>
        <Paragraph>
          Sie haben die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit
          sowie Widerspruch gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO. Sie können erteilte
          Einwilligungen jederzeit mit Wirkung für die Zukunft widerrufen. Zudem haben Sie das Recht auf Beschwerde bei
          einer Datenschutzaufsichtsbehörde. Zuständige Aufsichtsbehörde ist in der Regel der Landesbeauftragte für den
          Datenschutz und die Informationsfreiheit Baden-Württemberg.
        </Paragraph>

        <Title level={3}>15. Pflicht zur Bereitstellung von Daten</Title>
        <Paragraph>
          Für Registrierung und Nutzung bestimmter Funktionen sind bestimmte Angaben erforderlich. Ohne diese Angaben ist
          die Bereitstellung der entsprechenden Leistungen ggf. nicht möglich.
        </Paragraph>

        <Title level={3}>16. Keine automatisierte Entscheidungsfindung</Title>
        <Paragraph>
          Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO findet nicht
          statt. Die Tourenoptimierung dient der Berechnung und Planung von Routen und trifft keine rechtlich bindenden
          Entscheidungen über betroffene Personen.
        </Paragraph>

        <Title level={3}>17. Aktualisierung dieser Erklärung</Title>
        <Paragraph>
          Wir passen diese Datenschutzerklärung an, sobald Änderungen der Datenverarbeitung oder der rechtlichen
          Rahmenbedingungen dies erforderlich machen.
        </Paragraph>

        <Divider />
        <Paragraph><i>Stand: 22. Juli 2026</i></Paragraph>
      </Content>
    </Layout>
  );
}
